<template>
  <v-container>
     <v-layout row wrap justify-center>
        <v-flex xs10>
          <div class="blue-text text-center" v-html="termsData"></div>
        </v-flex>
     </v-layout>
    <v-img
      :src="packShot"
      contain
      class="packshot-footer"
    ></v-img>   
  </v-container>
</template>

<script>
export default {
  data: () => ({
    packShot : {src:require('../assets/Packshots.png')},
    termsData: ''
  }),
  beforeMount() {
    this.axios.get('/data/terms.html').then((response)=>{
      this.termsData = response.data
    });
  }
};
</script>
